import api from './api';

export const scoreLead = async (leadId) => {
  const response = await api.post('/ai/score-lead', { leadId });
  return response.data;
};

export const generateResponse = async ({ leadId, language, tone, channel }) => {
  const response = await api.post('/ai/generate-response', { leadId, language, tone, channel });
  return response.data;
};

export const matchStock = async (leadId) => {
  const response = await api.post('/ai/match-stock', { leadId });
  return response.data;
};

export const summarizeLead = async (leadId) => {
  const response = await api.post('/ai/summarize-lead', { leadId });
  return response.data;
};
